var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdGLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 16,
    viewBox: "0 0 93 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1443_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.1178 0.144653H25.5977V2.39802H82.1178V0.144653Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7547 0.144653H16.5352V2.27442H24.7547V0.144653Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.282 0.144653H83.0625V2.27442H91.282V0.144653Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0195312 15.7336V5.47058H4.20124C6.19374 5.47058 7.28718 6.93138 7.28718 8.68698C7.28718 10.4249 6.17738 11.8862 4.20124 11.8862H1.68399V15.7331H0.0195312V15.7336ZM5.58019 8.68748C5.58019 7.703 4.91292 7.05426 3.97368 7.05426H1.68399V10.303H3.97368C4.91338 10.3025 5.58019 9.6563 5.58019 8.68748Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36719 15.7336V5.47058H14.8652V7.05375H10.0302V9.70029H14.7671V11.288H10.0302V14.1505H14.8657V15.7336H8.36719Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1495 15.7336L18.1982 8.3937V15.7336H16.5352V5.47058H18.2417L23.0902 12.5784V5.47058H24.7547V15.7336H23.1495Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2648 15.7336L32.5685 13.749H28.2172L27.5209 15.7336H25.6289L29.3555 5.47058H31.4316L35.1582 15.7336H33.2648ZM30.3929 7.27017L28.6863 12.1643H32.0989L30.3929 7.27017Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8555 15.7336V5.47058H43.3811C46.3544 5.47058 48.3432 7.59378 48.3432 10.5943C48.3432 13.6261 46.3544 15.7336 43.3947 15.7336H39.8555ZM46.6357 10.5943C46.6357 8.62428 45.4993 7.05375 43.3947 7.05375H41.5181V14.1505H43.3806C45.4446 14.1505 46.6357 12.5481 46.6357 10.5943Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7734 15.7336V5.47058H56.2724V7.05375H51.4379V9.70029H56.1748V11.288H51.4379V14.1505H56.2724V15.7336H49.7734Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9414 15.7336V5.47058H64.4413V7.05375H59.6063V9.70029H64.3422V11.288H59.6063V15.7336H57.9414Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.75 15.7336V5.47058H67.4145V15.7336H65.75Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2656 15.7336V5.47058H70.9296V14.1505H75.1104V15.7336H69.2656Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1211 15.7336V5.47058H77.7856V14.1505H81.9663V15.7336H76.1211Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3203 10.6085C82.3203 7.5478 84.3254 5.30072 87.1693 5.30072C89.9987 5.30072 92.0183 7.5478 92.0183 10.6085C92.0183 13.6711 89.9987 15.9182 87.1693 15.9182C84.3254 15.9182 82.3203 13.6711 82.3203 10.6085ZM90.3113 10.6085C90.3113 8.48678 89.0749 6.89957 87.1688 6.89957C85.2497 6.89957 84.0254 8.48678 84.0254 10.6085C84.0254 12.7175 85.2492 14.3184 87.1688 14.3184C89.0749 14.3184 90.3113 12.7175 90.3113 10.6085Z",
    fill: "white",
    fillOpacity: 0.56
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1443_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 15.7735,
    fill: "white",
    transform: "translate(0.0195312 0.144653)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdGLogo);
export default __webpack_public_path__ + "static/media/PD_G_logo.0b1d900450101e677e540bbe76b5d377.svg";
export { ForwardRef as ReactComponent };